export function generateUUID() {
    let uuid = '';
    const hexValues = '0123456789abcdef';
    for(let i = 0; i < 36; i++){
        if (i === 8 || i === 13 || i === 18 || i === 23) {
            uuid += '-';
        } else if (i === 14) {
            uuid += '4';
        } else {
            uuid += hexValues.charAt(Math.floor(Math.random() * hexValues.length));
        }
    }
    return uuid;
}
export function isUUID(uuid) {
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(uuid);
}

//# sourceMappingURL=generate-uuid.js.map